import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import MainLayout from "../../layout";
import FormTextField from "../../components/form/text";
import { useNavigate, useParams } from "react-router-dom";
import successToast from "../../components/toast/successToast";
import errorToast from "../../components/toast/errorToast";
import { useEffect, useState } from "react";
import { FormImageField } from "../../components/form/image";
import { FormDropDown } from "../../components/form/dropdown";
import { FormToggleSwitch } from "../../components/form/checkbox";
import { FormTextAreaField } from "../../components/form/text-area";
import { api } from "../../redux/apis/api";

const EditCompany = () => {
  const naviagte = useNavigate();
  const params = useParams();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
  const [stateList, setstateList] = useState([]);
  const [citiesList, setCitiesList] = useState([]);

  const initialValues = {
    id: params?.id,
    name: data?.name ?? "",
    address: data?.address ?? "",
    state_id: data?.state_id ?? "",
    city_id: data?.city_id ?? "",
    email: data?.email ?? "",
    phone_number: data?.phone_number ?? "",
    logo: data?.logo ?? "",
    pan_number: data?.pan_number ?? "",
    gst_number: data?.gst_number ?? "",
    only_associated_data: data?.only_associated_data ?? false,
    bank_account_number: data?.bank_account_number ?? "",
    bank_ifsc_code: data?.bank_ifsc_code ?? "",
    bank_name: data?.bank_name ?? "",
    bank_account_holder_name: data?.bank_account_holder_name ?? "",
    upi_id: data?.upi_id ?? "",
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Required"),
    email: Yup.string().required("Required").email("Invalid email"),
  });

  const handleSubmit = (values) => {
    console.log(values, "values");
    api
      .post(`/company/edit`, values)
      .then((response) => {
        successToast(response.message);
        naviagte(`/company/list`);
      })
      .catch((error) => {
        console.error("API Error:", error);
        errorToast(error?.response?.data?.message);
      });
  };

  const fetchData = () => {
    setLoading(true);
    api
      .post(`/company/read`, {
        id: params?.id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const fetchStateDropDownData = () => {
    api
      .post(`/settings/state-dropdown`)
      .then((res) => {
        let newArr = res?.data?.data?.states?.map((ele) => ({
          label: ele.name,
          value: ele.id,
        }));
        setstateList(newArr);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  const fetchCityDropDownData = () => {
    api
      .post(`/settings/city-dropdown`)
      .then((res) => {
        let newArr = res?.data?.data?.cities?.map((ele) => ({
          label: ele.name,
          value: ele.id,
        }));
        setCitiesList(newArr);
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  useEffect(() => {
    fetchStateDropDownData();
    fetchCityDropDownData();
  }, []);

  return (
    <MainLayout>
      <section className="h-full overflow-auto md:px-3">
        {loading ? (
          <div className="h-full flex justify-center items-center">
            <div>
              <div className="animate-spin rounded-full h-10 w-10 border-4 border-primary border-t-transparent mx-2"></div>
              <p className="mt-2 text-sm text-gray-500">Loading...</p>
            </div>
          </div>
        ) : (
          <>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              enableReinitialize={true}
            >
              {({ values }) => (
                <Form>
                  <div className="flex justify-between items-center mb-5 sticky top-0 bg-background pb-2 z-10">
                    <h2 className="text-xl font-semibold capitalize">
                      company - Edit
                    </h2>
                    <div className="flex gap-3 items-center">
                      <button
                        onClick={() => naviagte("/company/list")}
                        type="button"
                        className="px-4 py-1 border-[2px] border-errorColor text-errorColor rounded"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="px-4 py-1 bg-primary border-[2px] border-primary text-white rounded"
                      >
                        Save
                      </button>
                    </div>
                  </div>

                  <section className="w-full max-w-[40rem]">
                    <div className="my-4">
                      <div className="my-4">
                        <FormImageField
                          name={"logo"}
                          label={"logo"}
                          value={values?.logo ?? ""}
                        />
                      </div>
                      <FormTextField
                        name={"name"}
                        label={"name"}
                        placeholder={`Enter company name`}
                        value={values?.name ?? ""}
                      />
                      <FormTextField
                        name={"email"}
                        label={"email"}
                        placeholder={`Enter company email`}
                        value={values?.email ?? ""}
                      />
                      <FormTextField
                        name={"phone_number"}
                        label={"phone number"}
                        placeholder={`Enter company phone number`}
                        value={values?.phone_number ?? ""}
                      />
                      <div className="my-4">
                        <FormDropDown
                          name="state_id"
                          label="state"
                          options={stateList}
                          value={stateList?.find(
                            (item) => item?.value === values?.state_id
                          )}
                        />
                      </div>
                      <div className="my-4">
                        <FormDropDown
                          name="city_id"
                          label="city"
                          options={citiesList}
                          value={citiesList?.find(
                            (item) => item?.value === values?.city_id
                          )}
                        />
                      </div>
                      <div className="my-4">
                        <FormTextAreaField
                          name={"address"}
                          label={"address"}
                          placeholder={`Enter company address`}
                          rows={3}
                          value={values?.address ?? ""}
                        />
                      </div>
                      <div className="my-4">
                        <FormTextField
                          name={"pan_number"}
                          label={"pan number"}
                          placeholder={`Enter pan number`}
                          value={values?.pan_number ?? ""}
                        />
                      </div>
                      <div className="my-4">
                        <FormTextField
                          name={"gst_number"}
                          label={"gst number"}
                          placeholder={`Enter gst number`}
                          value={values?.gst_number ?? ""}
                        />
                      </div>
                      <div className="my-4">
                        <FormToggleSwitch
                          name={"only_associated_data"}
                          label={"only associated data"}
                          value={values?.only_associated_data ?? false}
                        />
                      </div>
                    </div>
                  </section>
                  <div className="bg-[#1D72DB60] rounded-[4px] px-4 py-1">
                    <p>Bank Details</p>
                  </div>
                  <section className="w-full max-w-[40rem]">
                    <div className="my-4">
                      <FormTextField
                        name={"bank_name"}
                        label={"bank name"}
                        placeholder={`Enter bank name`}
                        value={values?.bank_name ?? ""}
                      />
                    </div>
                    <div className="my-4">
                      <FormTextField
                        name={"bank_account_number"}
                        label={"account number"}
                        placeholder={`Enter account number`}
                        value={values?.bank_account_number ?? ""}
                      />
                    </div>
                    <div className="my-4">
                      <FormTextField
                        name={"bank_ifsc_code"}
                        label={"bank ifsc code"}
                        placeholder={`Enter ifsc code`}
                        value={values?.bank_ifsc_code ?? ""}
                      />
                    </div>
                    <div className="my-4">
                      <FormTextField
                        name={"bank_account_holder_name"}
                        label={"account holder name"}
                        placeholder={`Enter your account holder name`}
                        value={values?.bank_account_holder_name ?? ""}
                      />
                    </div>
                    <FormTextField
                      name={"upi_id"}
                      label={"upi_id"}
                      placeholder={`Enter upi id`}
                      value={values?.upi_id ?? ""}
                    />
                  </section>
                </Form>
              )}
            </Formik>
          </>
        )}
      </section>
    </MainLayout>
  );
};

export default EditCompany;
